
import {
  defineComponent,
  ref,
  computed,
  PropType,
  reactive,
} from 'vue';
import { updateTtl } from '@/api/monitor-center-kt';
import type { IUpdateTtl, IKeysPageListItem } from '@/api/monitor-center-kt/type.d';
import { ElMessage } from 'element-plus';

export default defineComponent({
  name: 'UpdateVlaue',
  emits: ['update:visible', 'handleOperateSuccess'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<IKeysPageListItem>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formRef = ref();

    const formData = reactive<IUpdateTtl>({
      key: '',
      ttl: '',
    });

    const handleClose = () => {
      selfVisible.value = false;
      formRef.value.resetFields();
    };

    const handleSave = async () => {
      await formRef.value.validate();
      await updateTtl(formData);
      ElMessage.success('操作成功！');
      emit('handleOperateSuccess', {
        ...formData,
        value: props.data.value,
      });
      handleClose();
    };

    const handleOpen = () => {
      formData.key = props.data.key;
      formData.ttl = props.data.ttl;
    };

    return {
      formRef,
      formData,
      selfVisible,
      rules: {
        ttl: [
          { required: true, message: '请输入ttl', trigger: 'blur' },
        ],
      },
      handleClose,
      handleSave,
      handleOpen,
    };
  },
});
